import * as React from 'react';

import * as agui from 'arm-gui/dist/controls';
import { Utils, isAuth, NumberFormatter, domain, domainVal, i18n, DateFormatter } from 'arm-common';
import BtnDelete from '../shared/BtnDelete.jsx'
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import { connect } from 'react-redux';
import { isNullOrUndefined } from 'util';
import CategorieProdottoAction from './categorieProdottoActions'
import MicroCategorieTable from '../microCategorie/MicroCategoriaTable.jsx'
import MicroCategorieActions from '../microCategorie/microCaterogieActions'
import { resolve } from 'url';
import { reject } from 'lodash';

class CategoriaProdottoDetails extends React.Component {
    constructor(props) {
        super(props),
            this.componentName = "[CategoriaProdottoDetails.jsx]"
        this.state = {
            showConfirmDelete: false,
        }
        this.deleteCategoriaProdotto = this.deleteCategoriaProdotto.bind(this);
        this.showConfirmDelete = this.showConfirmDelete.bind(this);
        this.famigliaProdottoDetailsButton = this.famigliaProdottoDetailsButton.bind(this);
        this.inizializzaNuovoMicroCategoriaDaCategoria = this.inizializzaNuovoMicroCategoriaDaCategoria.bind(this);
        this.changeSelectedTab = this.changeSelectedTab.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        let idCategoria = null;

        if (isNullOrUndefined(this.props.location.state) || isNullOrUndefined(this.props.location.state.id)) {
            idCategoria = this.props.categoriaProdotto.id;
        } else {
            idCategoria = this.props.location.state.id;
        }

        this.props.getCategoriaProdottoDetails(idCategoria);

    }

    deleteCategoriaProdotto() {

        console.log(this.componentName + ' deleteCategoriaProdotto');

        this.showConfirmDelete();
        this.props.deleteCategoriaProdotto(this.props.categoriaProdotto.id).then(
            resolve => {
                this.props.history.push({ pathname: '/categorie/list' })
            },
            reject => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
            }
        );
        ;

    }
    showConfirmDelete() {
        console.log(this.componentName + ' showConfirmDelete');

        this.setState({ showConfirmDelete: !this.state.showConfirmDelete })

    }

    famigliaProdottoDetailsButton() {
        console.log(this.componentName + 'famigliaProdottoDetailsButton');
        this.props.history.push({
            pathname: '/famiglie/details', state: {
                id: this.props.categoriaProdotto.famigliaProdotto.id
            }
        });
    }

    inizializzaNuovoMicroCategoriaDaCategoria() {
        console.log(this.componentName + 'inizializzaNuovoMicroCategoriaDaCategoria');

        let idCategoria = this.props.categoriaProdotto.id;

        // aggiornamento della lista 
        this.props.getListCategorie().then(
            resolve => {
                this.props.inizializzaNuovoMicroCategoriaDaCategoria(idCategoria).then(

                    resolve => {
                        this.props.impostaCampiSuperioriMicroCategoria("idCategoriaProdotto").then(
                            resolve => {
                                // la imposto come famigliaProdottoOrigine per non riInzializzare il oggetto. 
                                this.props.history.push({
                                    pathname: '/microCategorie/create', state: {
                                        famigliaProdottoOrigine: true
                                    }
                                })
                            },
                            reject => {
                                console.log(this.componentName + 'impostaCampiSuperioriMicroCategoria KO');
                            }
                        )

                    },

                    reject => {

                        console.log(this.componentName + 'inizializzaNuovoMicroCategoriaDaCategoria KO');
                    }
                );

            })
    }

    changeSelectedTab(e) {
        if (e !== null && e !== undefined) {
            let idTab = e.target.id;
            this.props.changeSelectedTab(idTab);

        }
    }

    render() {
        return (
            <div className="card">
                <div className="card-header">
                    <h3> {i18n('ARM_CORE_PRODUCT.CATEGORIE.DETTAGLIO_CATEGORIA', 'Dettaglio Categoria')} {this.props.categoriaProdotto.nome} - id {this.props.categoriaProdotto.id}</h3>
                </div>
                <div className="card-body">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="active" >
                            <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLI', 'Dettagli')}</a>
                        </li>
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.MICRO-CATEGORIE') &&
                        <li className="nav-item">
                            <a className="nav-link " id="home-tab" onClick={this.changeSelectedTab} data-toggle="tab" href="#microcategorie" role="tab" aria-controls="microcategorie" aria-selected="true">{i18n('ARM_CORE_PRODUCT.MICROCATEGORIE.MICRO_CATEGORIE', 'Micro-Categorie')}</a>
                        </li>
    }
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <div className="row mt-3">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.NOME', 'Nome')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.categoriaProdotto ? this.props.categoriaProdotto.nome : "-"}</dd>
                                <dt className="col-sm-2 col-6 mt-2">{i18n('ARM_CORE_PRODUCT.SHARED.FAMIGLIA_PRODOTTO', 'Famiglia Prodotto')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.categoriaProdotto.famigliaProdotto ? <button type="button" className="btn btn-link" onClick={this.famigliaProdottoDetailsButton}>{this.props.categoriaProdotto.famigliaProdotto.nome} </button> : null}</dd>
                            </div>
                            <div className="row mt-3">
                                <dt className="col-sm-2 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZINE', 'Descrizione')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.categoriaProdotto ? this.props.categoriaProdotto.descrizione : "-"}</dd>
                            </div>
                            <div className="row mt-3">
                                {/* <dt className="col-sm-2 col-4 ">{i18n('ARM_CORE_PRODUCT.SHARED.SINGLA', 'Sigla')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.categoriaProdotto ? this.props.categoriaProdotto.sigla : "-"}</dd> */}
                                <dt className="col-sm-2 col-6 ">{i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.categoriaProdotto ? this.props.categoriaProdotto.ordVis : "-"}</dd>
                            </div>

                            <dl className="row mt-3">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.INSERITO_DA', 'Inserito da')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.categoriaProdotto.insertUser}</dd>
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERIMENTO', 'Data Inserimento')}</dt>
                                <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.categoriaProdotto.insertDate)}</dd>
                            </dl>

                            <dl className="row mt-3">
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da')}</dt>
                                <dd className="col-sm-4 col-6">{this.props.categoriaProdotto.updateUser}</dd>
                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_MODIFICA', 'Data Modifica')}</dt>
                                <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.categoriaProdotto.updateDate)}</dd>
                            </dl>

                        </div>
                        <div className="tab-pane fade" id="microcategorie" role="tabpanel" aria-labelledby="microcategorie-tab">
                            {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                                <agui.aButton bs="primary" className="float-left mt-2" icon="fas fa-plus" onClick={this.inizializzaNuovoMicroCategoriaDaCategoria}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')}</agui.aButton>
                            }
                            <MicroCategorieTable rows={this.props.categoriaProdotto.listMicroCategorie} history={this.props.history} />
                        </div>
                    </div>
                </div>
                <div className="card-footer mb-2">
                    <div className="float-left">
                        {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                            <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" href="#/categorie/create">{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>
                        }
                        {isAuth('V2.ADMIN.PRODUCT.DELETE') &&
                            <BtnDelete onClick={this.showConfirmDelete} className="float-right mr-2" ></BtnDelete>
                        }
                    </div>
                    <agui.aButton bs="secondary" className="float-right mr-2" href="#/categorie/list" >{i18n('ARM_CORE_PRODUCT.SHARED.TORNA_ALLA_LISTA', 'Torna alla lista')}</agui.aButton>
                </div>
                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.deleteCategoriaProdotto}
                    onClose={this.showConfirmDelete} />
            </div>


        )
    }
}

function mapDispatchToProps(dispatch) {
    return {

        deleteCategoriaProdotto(id) {
            return dispatch(CategorieProdottoAction.deleteCategoria(id))
        },
        getCategoriaProdottoDetails(id) {
            return dispatch(CategorieProdottoAction.getCategoriaDetails(id));
        },
        inizializzaNuovaCategoria() {
            return dispatch(CategorieProdottoAction.inizializzaNuovaCategoria())
        },
        inizializzaNuovoMicroCategoriaDaCategoria(idCategoria) {
            return dispatch(MicroCategorieActions.inizializzaNuovoMicroCategoriaDaCategoria(idCategoria))
        },
        impostaCampiSuperioriMicroCategoria(campo) {
            return dispatch(MicroCategorieActions.impostaCampiSuperioriMicroCategorie(campo));
        },
        getListCategorie() {
            return dispatch(CategorieProdottoAction.getListaCategorie());
        },
        changeSelectedTab(idTab) {
            return dispatch(MicroCategorieActions.changeSelectedTab(idTab));
        },

    }
};

function mapStateToProps(state) {
    return {
        categoriaProdotto: state.categorieProdotto.categoriaProdotto,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(CategoriaProdottoDetails)